'use strict';

const SELECTORS = {
    levels: '.js-memberships-donation',
    form: '.memberships-donation__form',
    monthlyAmount: '.js-monthly-amount',
    quarterlyAmount: '.js-quarterly-amount',
};

(function () {
    const levelEls = document.querySelectorAll(SELECTORS.levels);
    const form = document.querySelector(SELECTORS.form);
    let membership_level = '';
    let onAccountMethodId;

    levelEls.forEach(element => {
        const target = document.querySelector(
            element.dataset.membershipTarget || '.memberships-donation'
        );
        const defaultDonation = element.dataset.membershipDefaultDonation || 100;
        const visibleClass = element.dataset.membershipToggleClass || 'is-toggled';
        const input = document.querySelector(
            element.dataset.membershipInput || '.memberships-donation__amount'
        );

        element.addEventListener('click', ev => {
            if (target.classList.contains(visibleClass) === false) {
                target.classList.add(visibleClass);
            }
            membership_level = ev.target.dataset.membershipLevel;
            onAccountMethodId = ev.target.dataset.onAccountMethodId;
            input.value = defaultDonation;
            ev = new Event('change');
            input.dispatchEvent(ev);
        }, false);
    });

    function updateBillableAmounts() {
        if (form) {
            const formData = new FormData(form);

            const totalValue = parseFloat(formData.get('amount').replace(/,/g, ''));
            const numberFormater = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});

            const monthlyAmountEl = form.querySelector(SELECTORS.monthlyAmount);
            const quarterlyAmountEl = form.querySelector(SELECTORS.quarterlyAmount);

            if (monthlyAmountEl) {
                monthlyAmountEl.innerText = numberFormater.format(totalValue / 12);
            }

            if (quarterlyAmountEl) {
                quarterlyAmountEl.innerText = numberFormater.format(totalValue / 4);
            }
        }
    }

    if (form) {
        form.querySelector('input[name="amount"]').addEventListener('keyup', updateBillableAmounts);
        form.querySelector('input[name="amount"]').addEventListener('change', updateBillableAmounts);
        form.querySelectorAll('input[type="radio"]').forEach(el => {
            el.addEventListener('click', updateBillableAmounts);
        });

        form.addEventListener('submit', ev => {
            ev.preventDefault();
            const data = new FormData(form);
            const action = form
                .dataset
                .formAction
                .replace('{{amount}}', data.get('amount').replace(/,/g, '')) // Strip out comma separators for thousands etc
                .replace('{{on_account_method_id}}', onAccountMethodId);
            if (membership_level) {
                window.location = `${action}?payment-frequency=${data.get('payment-frequency')}&level=${membership_level}`;
            } else {
                window.location = `${action}?payment-frequency=${data.get('payment-frequency')}`;
            }
            return false;
        });
    }
}());
